var React = require('react');

function BeatsInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"className":"st0","d":"M48.9,63.5c8.1,0,14.7-6.6,14.7-14.7S57,34.2,48.9,34.2c-8.1,0-14.7,6.6-14.7,14.7S40.7,63.5,48.9,63.5z"})),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M48.9,0c-5,0-9.7,0.7-14.2,2.1v25.6c4-2.7,8.8-4.2,14-4.2c14.1,0,25.5,11.4,25.5,25.5\n\t\t\t\tc0,14.1-11.4,25.5-25.5,25.5C34.6,74.4,23.2,63,23.2,49c0-0.5,0-1.5,0-1.5V7.3C9.2,15.9,0,31.3,0,48.9c0,27,21.9,48.9,48.9,48.9\n\t\t\t\tc27,0,48.9-21.9,48.9-48.9S75.9,0,48.9,0z"}))])));
}

BeatsInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 98 98","style":{"enableBackground":"new 0 0 98 98"},"xmlSpace":"preserve"};

module.exports = BeatsInline;

BeatsInline.default = BeatsInline;
